<template>
    <div>
        <v-container>
            <v-row>
                <v-col cols="12">
                    <div class="grey--text">
                        Posted On  {{ dateutils.utcToLocalDisplay(questionDetails.created_at) }}
                    </div>
                    <h1 class="mb-2">
                        {{ questionDetails.title }}
                    </h1>
                    <h4 class="grey--text text--darken-2 font-weight-regular" style="overflow-wrap:anywhere;">
                        {{ questionDetails.description }}
                    </h4>
                </v-col>
                <v-col cols="12">
                    <h4 class="grey--text text--darken-3 mb-2 font-weight-regular">
                        Health Concern:
                    </h4>
                    <v-chip v-for="specialization in questionDetails.specializations" :key="specialization.id">
                        {{ specialization.name }}
                    </v-chip>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12">
                    <v-divider></v-divider>
                    <h3 class="font-weight-regular mt-4">Answers ({{ questionDetails.total_answers }}) </h3>
                </v-col>
                <v-col col="12" sm="12" class="pt-0">
                    <v-list three-line>
                        <template v-for="answer in questionDetails.answers">
                            <v-list-item
                                    :key="answer.id"
                                    class=""
                            >                                

                                <v-list-item-avatar @click="showDoctorProfile(answer.doctor)" class="pointer" v-if="!answer.doctor.profile_image_path">
                                    <v-icon color="primary" style="font-size: 50px">mdi-account-circle</v-icon>
                                </v-list-item-avatar>
                                <v-list-item-avatar @click="showDoctorProfile(answer.doctor)" class="pointer" v-else>
                                  <v-img :src="apiUrl+'/storage/'+answer.doctor.profile_image_path"></v-img>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        <div class="d-flex justify-space-between">
                                            <div>
                                            {{ answer.doctor.salutation }} {{ answer.doctor.name }}
                                            </div>
                                            <div style="font-size:14px;">
                                                {{ dateutils.utcToLocalDisplay(answer.created_at) }}
                                            </div>
                                        </div>
                                    </v-list-item-title>
                                    <div>
                                        {{ answer.response }}
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider :key="answer.id"></v-divider>
                        </template>
                    </v-list>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: "QuestionDetails",
        props: ['questionDetails'],
        mounted() {
            // this.getQuestionDetails();
        },
        data() {
            return {
                apiUrl:process.env.VUE_APP_API_URL,
            }
        },
        methods: {
            showDoctorProfile(doctor) {
                var path = process.env.VUE_APP_WEBSITE_URL+"/doctors/"+ doctor.unique_no +"/"+this.getSlugFromString(doctor.name)

                window.open(path)            
            },
        }
    }
</script>

<style>

</style>